<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  ready: { type: Boolean, default: false },
  provider: { type: String, default: 'evolution_go' },
  officialAvailable: { type: Boolean, default: true },
});
const model = defineModel({ type: String, default: 'evolution_go' });
const { t } = useI18n();
</script>

<template>
  <div class="flex min-w-0 flex-col gap-2 border-b border-n-weak px-3 py-2">
    <div class="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2">
      <span class="shrink-0 text-xs font-medium text-n-slate-11">
        {{ t('CONVERSATION.HYBRID.SEND_VIA') }}
      </span>
      <div
        role="group"
        :aria-label="t('CONVERSATION.HYBRID.SEND_VIA')"
        class="grid min-w-0 max-w-full grid-cols-2 gap-1 rounded-lg bg-n-alpha-2 p-1"
      >
        <button
          v-for="option in [
            { value: 'ycloud', label: t('CONVERSATION.HYBRID.OFFICIAL') },
            { value: provider, label: t('CONVERSATION.HYBRID.QR') },
          ]"
          :key="option.value"
          type="button"
          :aria-pressed="model === option.value"
          class="min-h-9 min-w-0 rounded-md px-3 py-1.5 text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-n-brand"
          :class="
            model === option.value
              ? 'bg-n-solid-2 text-n-slate-12 shadow-sm'
              : 'text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-slate-12'
          "
          @click="model = option.value"
        >
          {{ option.label }}
        </button>
      </div>
    </div>
    <p
      v-if="model !== 'ycloud' && !ready"
      role="status"
      class="m-0 text-xs leading-5 text-n-ruby-11"
    >
      {{ t('CONVERSATION.HYBRID.UNAVAILABLE') }}
    </p>
    <p
      v-else-if="model === 'ycloud' && !officialAvailable"
      role="status"
      class="m-0 text-xs leading-5 text-n-slate-11"
    >
      {{ t('CONVERSATION.HYBRID.WINDOW_CLOSED') }}
    </p>
  </div>
</template>
